import { render, staticRenderFns } from "./WriteNotification.vue?vue&type=template&id=26516c82&scoped=true"
import script from "./WriteNotification.vue?vue&type=script&lang=js"
export * from "./WriteNotification.vue?vue&type=script&lang=js"
import style0 from "./WriteNotification.vue?vue&type=style&index=0&id=26516c82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26516c82",
  null
  
)

export default component.exports